import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';

const DeleteRFPModal = ({ item, isDeleting, onConfirm, onCancel }) => {
    if (!item) return null;

    const rfpName = item.proposal_title || item.filename || 'this document';
    
    return (
        <div className="custom-modal-overlay">
            <div className="delete-modal-content">
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
                    <AlertTriangle size={24} color="#EF4444" />
                    <h2 style={{ margin: 0 }}>Confirm Delete</h2>
                </div>
                
                <p className="modal-main-text">
                    Are you sure you want to delete <strong>{rfpName}</strong>?
                </p>
                <p className="modal-subtext">
                    This action cannot be undone and will remove all associated analysis data.
                </p>
                
                <div className="modal-actions">
                    <button 
                        className="modal-cancel-btn" 
                        onClick={onCancel}
                        disabled={isDeleting}
                    >
                        Cancel
                    </button>
                    <button 
                        className="modal-delete-btn" 
                        onClick={onConfirm}
                        disabled={isDeleting}
                    >
                        {isDeleting ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <Loader2 size={16} className="loader-spin" /> 
                                <span>Deleting...</span>
                            </div>
                        ) : (
                            'Yes, Delete'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteRFPModal;

